<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Wrapper -->
<div class="flex flex-col flex-auto items-center w-full min-w-0 bg-gray-200 dark:bg-card">

    <!-- Header -->
    <div class="relative flex flex-col flex-0 justify-center w-full h-16 overflow-hidden dark:shadow-none print:hidden">
        <!-- Top bar -->
        <div class="relative dark flex flex-auto justify-center w-full px-4 bg-gray-200 dark:bg-gray-900">
            <div class="flex items-center w-full">
                <!-- Logo -->
                <ng-container>
                    <div class="flex items-center text-black">
                        <img class="w-10 mr-3" src="assets/images/logo/scheduler_logo.png" alt="Logo image">
                        <span *ngIf="accountName" class="font-sans">Booking Page of {{accountName}}</span>
                        <span *ngIf="!accountName" class="font-sans">LollyLaw</span>
                    </div>
                </ng-container>
                <!-- Navigation toggle button -->
                <!--
                <ng-container>
                    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
                        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                    </button>
                </ng-container>
                -->
            </div>
        </div>

    </div>

    <!-- Content -->
    <div class="flex flex-auto justify-center w-full sm:p-3 md:p-3">
        <div
            class="flex flex-col flex-auto w-full  sm:shadow-lg sm:rounded-lg sm:overflow-hidden bg-default">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                 Otherwise, layout changes won't be registered and the view won't be updated! -->
            <router-outlet *ngIf="true"></router-outlet>
        </div>
    </div>
    <!-- Footer -->
    <div class="relative flex flex-0 justify-center w-full px-6 md:px-8 z-100 border-t bg-gray-200 print:hidden">
        <div class="flex flex-col items-center justify-center w-full max-w-screen-md space-y-1 p-2">
            <div class="text-sm text-center">
                Powered by LollyLaw
                <!--
              <a 
                href="https://lollylaw.com" 
                target="_blank" 
                class="text-blue-500 hover:underline">
                LollyLaw
              </a>
              -->
                <span class="text-sm font-medium text-gray-700">
                    © 2025
                </span>
            </div>
            <div class="text-sm text-gray-600 text-center">
                Use of the software is subject to the
                <a href="https://lollylaw.com/privacy-policy/" target="_blank" class="text-blue-500 hover:underline">
                    Privacy Policy
                </a>
                <span> and </span>
                <a href="https://lollylaw.com/terms-of-service/" target="_blank" class="text-blue-500 hover:underline">
                    Terms of Service.
                </a>

            </div>
        </div>
    </div>
</div>